import { render } from "./routes.vue?vue&type=template&id=4e89a9de&scoped=true"
import script from "./routes.vue?vue&type=script&lang=js"
export * from "./routes.vue?vue&type=script&lang=js"

import "./routes.vue?vue&type=style&index=0&id=4e89a9de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e89a9de"]])

export default __exports__